// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Empty_wrapper__1RcMe","title":"Empty_title__2Qz-T","subtitle":"Empty_subtitle__3zSDC"};